"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUserSegmentationParams = void 0;
var _nullableStringToInt = require("../internals/nullableStringToInt");
/**
 * Parses the Next.js query parameters and returns an object with parsed user segmentation values.
 * @param params The segmentation query parameters.
 * @returns An object with the parsed values of `atpClusterId` and `customerTypeId`.
 * @throws Error if `atpClusterId` or `customerTypeId` is missing.
 */
const parseUserSegmentationParams = params => {
  if (!params) {
    throw new Error('Params are required');
  }
  const {
    atpClusterId,
    customerTypeId
  } = params;
  if (!atpClusterId) {
    throw new Error('atpClusterId query param is required');
  }
  if (!customerTypeId) {
    throw new Error('customerTypeId query param is required');
  }
  return {
    atpClusterId: (0, _nullableStringToInt.nullableStringToInt)(atpClusterId),
    customerTypeId: (0, _nullableStringToInt.nullableStringToInt)(customerTypeId)
  };
};
exports.parseUserSegmentationParams = parseUserSegmentationParams;
